import React from 'react';
import { Box, Typography } from '@mui/material';

import SwitchInput from '../../../../../Components/SwitchInput';
import InfoButton from '../../../../../Components/InfoButton';

import useStyles from './styles';
import CustomHeading from '../../../../../Components/CustomHeading';

const FloorAutomationToggle = ({ gamUprFloorAutomationEnabled, onToggle, infoMessage }) => {
	const classes = useStyles();

	const statusClass = gamUprFloorAutomationEnabled
		? classes.gamUprAutomationStatusEnabled
		: classes.gamUprAutomationStatusDisabled;

	const dotClass = gamUprFloorAutomationEnabled
		? classes.gamUprAutomationDotEnabled
		: classes.gamUprAutomationDotDisabled;

	return (
		<Box className={classes.gamUprAutomationContainer}>
			<Box className={classes.gamUprAutomationWrapper}>
				<Box className={classes.gamUprAutomationContent}>
					<Box className={`${classes.gamUprAutomationDot} ${dotClass}`} />

					<Box>
						<Box className={classes.gamUprAutomationHeader}>
							<CustomHeading
								heading={'Automated Floors'}
								name={`GAM_UPR_FLOOR_AUTOMATION.HEADING`}
								variantType="h7"
								headingClassName={classes.gamUprAutomationTitle}
							/>

							<InfoButton message={infoMessage} />
						</Box>

						<CustomHeading
							heading={gamUprFloorAutomationEnabled ? '✓ Active and Running' : 'Inactive'}
							name={`GAM_UPR_FLOOR_AUTOMATION.STATUS`}
							variantType="h7"
							headingClassName={statusClass}
						/>
					</Box>
				</Box>

				<Box sx={{ marginLeft: '4rem' }}>
					<SwitchInput
						isObjectEditor={false}
						directValue={gamUprFloorAutomationEnabled}
						updateDirectValue={onToggle}
						keyData={'GAM_UPR_FLOOR_AUTOMATION'}
					/>
				</Box>
			</Box>

			{gamUprFloorAutomationEnabled && (
				<Box className={classes.gamUprAutomationInfoBox}>
					<Typography className={classes.gamUprAutomationInfoText}>
						<Box component="span" sx={{ fontWeight: 700 }}>
							Automated Floors is running
						</Box>
						— Optimizing floor configurations across all regions in real-time.
					</Typography>
				</Box>
			)}
		</Box>
	);
};

export default FloorAutomationToggle;
